import { viewport, inViewport } from '../../utils/Utils';

($ => {
  let animationFrameInitialized = false; // Needed for functions where you can't use .once()
  let lastScrollTop = 0;
  let ticking = false;
  let menuMoved = false;

  $(window).on('load', () => {
    lastScrollTop = $(document).scrollTop();
  });

  const update = () => {
    ticking = false;
    const st = $(document).scrollTop();

    // Top nav.
    if (viewport().width < 768) {
      $('body').addClass('screen-small'); // not used?
      if (!menuMoved) {
        $('.info_block--items a').each((index, element) => {
          $(element).addClass('info_item');
          $(element).appendTo('.menu_block--items');
        });
        $('.language_block').appendTo('.menu_block--items');
        $('.search_block').appendTo('.menu_block--items');
        menuMoved = true;
      }
    } else {
      $('body').removeClass('screen-small'); // not used?
      if (menuMoved) {
        $('.menu_block--items .info_item').each((index, element) => {
          $(element).removeClass('info_item');
          $(element).appendTo('.info_block--items');
        });
        $('.language_block').appendTo('.info_block');
        $('.search_block').appendTo('.info_block');

        menuMoved = false;
      }
    }

    // Sidebar scrolling.
    const $menuSidebarContent = $('.menu_sidebar_block--content');
    if ($('.menu_sidebar_block_menu').length) {
      if ($(window).innerWidth() >= 900) {
        if ($menuSidebarContent.hasClass('noscroll')) {
          $menuSidebarContent.removeClass('noscroll');
          $('.menu_sidebar_block--items').addClass('open');
          $('.menu_sidebar_block--items').show();
        }

        let isTablet = false;
        if (
          (window.screen.width <= 768 && window.screen.height <= 1024) ||
          (window.screen.width <= 1024 && window.screen.height <= 768)
        ) {
          isTablet = true;
        }

        const headerHeight = $('header')[0].getBoundingClientRect().bottom;
        const bottomVisible =
          $menuSidebarContent[0].getBoundingClientRect().bottom <=
          window.innerHeight;
        const topVisible =
          $menuSidebarContent[0].getBoundingClientRect().top >= headerHeight;
        const deltaY = st - lastScrollTop;
        const footerVisible =
          $('footer')[0].getBoundingClientRect().top <= $(window).innerHeight();
        const $breadcrumb = $('.breadcrumb')[0];
        let breadcrumbVisible;

        if ($breadcrumb) {
          breadcrumbVisible =
            $('.breadcrumb')[0].getBoundingClientRect().bottom > headerHeight;
        }

        const teaserHeight = $('.menu_sidebar_block--teaser').outerHeight();
        $menuSidebarContent.css({ 'padding-bottom': `${teaserHeight}px` });

        if (!isTablet) {
          if (
            $('main')[0].getBoundingClientRect().top >=
            $('header')[0].getBoundingClientRect().bottom
          ) {
            const h = inViewport($('main'));
            $menuSidebarContent.css({ 'min-height': `${h}px` });
          } else {
            const h =
              $(window).innerHeight() -
              $('header')[0].getBoundingClientRect().bottom;
            $menuSidebarContent.css({ 'min-height': `${h}px` });
          }

          if (breadcrumbVisible) {
            $menuSidebarContent.css({ position: 'absolute' });
            $menuSidebarContent.css({ bottom: 'auto', top: '0' });
          } else if (footerVisible) {
            $menuSidebarContent.css({ position: 'absolute' });
            $menuSidebarContent.css({ top: 'auto', bottom: '0' });
          } else if (deltaY > 0) {
            if (bottomVisible) {
              $('.menu_sidebar_block--content').css({
                position: 'fixed',
                top: 'auto',
                bottom: '0px',
              });
            } else {
              const temp =
                parseInt($menuSidebarContent.css('top'), 10) + deltaY * -1;
              $menuSidebarContent.css({
                position: 'fixed',
                top: `${temp}px`,
                bottom: 'auto',
              });
            }
          } else if (deltaY < 0) {
            if (topVisible) {
              $menuSidebarContent.css({
                position: 'fixed',
                top: `${headerHeight}px`,
                bottom: 'auto',
              });
            } else {
              const temp =
                parseInt($menuSidebarContent.css('bottom'), 10) + deltaY;
              $menuSidebarContent.css({
                position: 'fixed',
                top: 'auto',
                bottom: `${temp}px`,
              });
            }
          }
        }
      } else {
        if (!$menuSidebarContent.hasClass('noscroll')) {
          $menuSidebarContent.addClass('noscroll');
          $menuSidebarContent.css({
            position: 'relative',
            top: 'auto',
            bottom: 'auto',
          });
        }

        $menuSidebarContent.css({ 'padding-bottom': '0' });
        $menuSidebarContent.css({ 'min-height': '0' });
      }
    }

    lastScrollTop = st;

    requestAnimationFrame(update);
  };

  const initializeAnimationFrame = () => {
    if (!animationFrameInitialized) {
      animationFrameInitialized = true;
      requestAnimationFrame(update);
    }
  };

  const setHeightSidebar = () => {
    if ($(window).width() > 768) {
      const heightMain = $('.layout-content').height();
      const heightSideBar = $('.menu_sidebar_block--content').height();
      if (heightMain > heightSideBar) {
        $('.menu_sidebar_block_menu').height(heightMain);
      } else {
        $('.main-content-block').height(heightSideBar);
      }
    }
  };

  Drupal.behaviors.sidemenu = {
    attach(context) {
      setHeightSidebar();
      $('.menu_sidebar_block--title-mobile', context).click(e => {
        if ($('.menu_sidebar_block--items').hasClass('open')) {
          $(e.currentTarget).removeClass('open');
          $('.menu_sidebar_block--items').removeClass('open');
          $('.menu_sidebar_block--items').slideUp(250);
        } else {
          $(e.currentTarget).addClass('open');
          $('.menu_sidebar_block--items').addClass('open');
          $('.menu_sidebar_block--items').slideDown(250);
        }
      });
    },
  };

  Drupal.behaviors.updateTicks = {
    attach() {
      /* $(window, context).resize(function () {
        requestTick();
      });

      $(window, context).scroll(function () {
        requestTick();
      }); */
      // Changed to run constantly because it wouldn't trigger on animations.
      initializeAnimationFrame();
    },
  };

  const requestTick = () => {
    if (!ticking) {
      requestAnimationFrame(update);
    }
    ticking = true;
  };

  Drupal.behaviors.sidebarMenuCollaps = {
    attach(context) {
      $('.menu-item--active-trail').addClass('menu-item--open-click');
      $('.menu-item--expanded-arrow', context).on('click', e => {
        const parentElement = $(e.target).parent()[0];
        parentElement.classList.toggle('menu-item--open-click');
        setTimeout(() => {
          setHeightSidebar();
        }, 500);
      });
    },
  };

  Drupal.behaviors.audioTeaser = {
    attach(context) {
      $('.menu_sidebar_block--teaser-audio a', context).click(e => {
        e.preventDefault();

        const audioElement = $('.menu_sidebar_block--teaser-audio audio')[0];

        if (audioElement.duration > 0 && !audioElement.paused) {
          audioElement.pause();
          audioElement.currentTime = 0;
        } else {
          audioElement.play();
        }
      });
    },
  };
})(jQuery);
